import { useQueryClient as d, useQuery as c } from "@tanstack/react-query";
import { httpClient as i } from "../../../utils/http-client.mjs";
const q = ({ id: t, fileManagerApiType: e }, r) => {
  const n = d(), s = ["file-details", { id: t }], a = () => e != null && e.isCommon ? "/api/dashboard/management/data-files/" : "/api/dashboard/customer/data-files/";
  return { ...c({
    queryKey: s,
    retry: !1,
    refetchInterval: !1,
    refetchOnWindowFocus: !1,
    enabled: typeof t < "u",
    queryFn: async ({ queryKey: o }) => {
      const [, { id: u }] = o;
      return (await i.get(a() + u)).data;
    },
    ...r
  }), resetAndRefetch: () => {
    n.invalidateQueries({ queryKey: s });
  } };
};
export {
  q as useFileDetails
};
